// Pure mappers: raw blustreamApi shapes -> the shapes deriveModel / the segment summary consume.
export function adaptTouchpoint(tp) {
  const asId = (v) => (v != null ? String(v) : null);
  return {
    touchpoint_id: tp.touchpoint_id,
    journey_id: tp.journey_id,
    ordinal: tp.ordinal,
    name: tp.name,
    message: tp.message,
    wait_time: tp.wait_time,
    response_attribute_id: asId(tp.response_attribute_id),
    touchpoint_sent_attribute_id: asId(tp.touchpoint_sent_attribute_id),
    link_click_attribute_id: asId(tp.link_click_attribute_id),
    is_active: tp.is_active !== false,
    link: tp.link || null,
    labels: tp.labels || [],
  };
}

export function adaptJourney(j, touchpoints = []) {
  return {
    journey_id: j.journey_id,
    name: j.name,
    state_enum: j.state_enum,
    is_active: j.is_active,
    segment_id: j.segment_id,
    channels: j.channels || [], // real API has no channels; keep [] so meta/joins are safe
    labels: j.labels || [],
    is_restartable: !!j.is_restartable,
    is_recurring: !!j.is_recurring,
    recurrence_spec: j.recurrence_spec || null,
    touchpoints: touchpoints.map(adaptTouchpoint),
  };
}

export const adaptSegment = (s) => s; // condition shape already matches the model

export function buildAttributeIndex(attrs = []) {
  const byId = new Map(attrs.map((a) => [String(a.attribute_id), { attribute_id: a.attribute_id, name: a.name }]));
  return (id) => byId.get(String(id)) || null;
}
